import en from './locales/en.json';
import de from './locales/de.json';

export const dataExportLocales = {
  en: { dataExport: en },
  de: { dataExport: de },
};

export { default as DataExportPage } from './DataExportPage.vue';
export * from './components';
export * from './composables';
export * from './data-export.routes';
export { EXPORT_FORMATS, type ExportFormat } from './internal/data-export.constants';
export type { DataExportRequest } from './internal/data-export.types';
